const page_schema = {
	"tiers": [
		{
			"name": "Categories",
			"type": "checkbox",
			"id": "categories",
			"class_name": "tags",
			"child_name": "categorie",
			"options": [
				{
					"name": "Transcriptomics",
					"id": "transcriptomics"
				},
				{
					"name": "Microbiomics",
					"id": "microbiomics"
				},
				{
					"name": "Epigenetics",
					"id": "epigenetics"
				},
				{
					"name": "Genomics",
					"id": "genomics"
				},
			]
		},
		{
			"name": "Targets",
			"type": "checkbox",
			"id": "targets",
			"class_name": "tags",
			"child_name": "target",
			"options": [
				{
					"name": "rRNA Depletion-Based",
					"id": "rrna-depletion-based"
				},
				{
					"name": "Oligo-dT Primer-Based",
					"id": "oligo-dt-primer-based"
				},
				{
					"name": "Coding and a Variety of Non Coding",
					"id": "coding-and-a-variety-of-non-coding"
				},
				{
					"name": "Coding Only",
					"id": "coding-only"
				},
				{
					"name": "5mC: Whole Genome",
					"id": "5mc-whole-genome"
				},
				{
					"name": "5mC: Reduced Representation",
					"id": "5mc-reduced-representation"
				},
				{
					"name": "5hmC",
					"id": "5hmc"
				},
				{
					"name": "Bisulfite",
					"id": "bisulfite"
				},
				{
					"name": "Non-Bisulfite",
					"id": "non-bisulfite"
				},
				{
					"name": "Chromatin",
					"id": "chromatin"
				},
				{
					"name": "Fragmentomics",
					"id": "fragmentomics"
				},
				{
					"name": "Whole Genome DNA-Seq",
					"id": "whole-genome-dna-seq"
				},
			]
		},
		{
			"name": "Formats",
			"type": "checkbox",
			"id": "formats",
			"class_name": "tags",
			"child_name": "format",
			"options": [
				{
					"name": "10 Preps",
					"id": "10-preps"
				},
				{
					"name": "12 Preps",
					"id": "12-preps"
				},
				{
					"name": "24 Preps",
					"id": "24-preps"
				},
				{
					"name": "25 Preps",
					"id": "25-preps"
				},
				{
					"name": "48 Preps",
					"id": "48-preps"
				},
				{
					"name": "96 Preps",
					"id": "96-preps"
				},
			]
		},
	],
	filters: [],
	"products": {
		"Zymo-Seq SwitchFree 3′ mRNA Library Kit": {
			"title": "Zymo-Seq SwitchFree 3′ mRNA Library Kit",
			"catalogNumbers": "R3008, R3009",
			"description": "UMI-integrated, simple 3′ mRNA library preparation in ~4 hours with scalable sample multiplexing suitable for high-throughput protein coding gene counting.",
			"handle": "/products/zymo-seq-switchfree-3-mrna-library-kit",
			"navigation_image": "https://files.zymoresearch.com/product-images/r3008_zymo_seq_switchfree_3_mrna_library_kit_2.jpg",
			"generalIndex": "998",
			"id": "zymo-seq-switchfree-3-mrna-library-kit",
			"tags": [
				"transcriptomics",
				"oligo-dt-primer-based",
				"coding-only",
				"12-preps",
				"96-preps",
			],
			filters: []
		},
		"Zymo-Seq RiboFree Total RNA Library Kit": {
			"title": "Zymo-Seq RiboFree Total RNA Library Kit",
			"catalogNumbers": "R3000, R3003",
			"description": "One for all. Simplest and all-inclusive total RNA-Seq library preparation kit with universal rRNA depletion for any organism.",
			"handle": "/products/zymo-seq-ribofree-total-rna-library-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/R3000Zymo-SeqRiboFreeTotalRNALibraryKit.jpg?v=1686677245&width=600",
			"generalIndex": "998",
			"id": "zymo-seq-ribofree-total-rna-library-kit",
			"tags": [
				"transcriptomics",
				"rrna-depletion-based",
				"coding-and-a-variety-of-non-coding",
				"12-preps",
				"96-preps",
			],
			filters: []
		},
		"Zymo-Seq RiboFree Universal cDNA Kit": {
			"title": "Zymo-Seq RiboFree Universal cDNA Kit",
			"catalogNumbers": "R3001",
			"description": "Simplest NGS-Grade cDNA kit with universal rRNA depletion for any organism.",
			"handle": "/products/zymo-seq-ribofree-universal-cdna-kit?",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/Zymo-SeqRiboFreeUniversalcDNAKit_Custom.jpg?v=1686690637&width=600",
			"generalIndex": "998",
			"id": "zymo-seq-ribofree-universal-cdna-kit?",
			"tags": [
				"transcriptomics",
				"rrna-depletion-based",
				"coding-and-a-variety-of-non-coding",
				"12-preps",
			],
			filters: []
		},
		"Zymo-Seq UDI Primer Sets": {
			"title": "Zymo-Seq UDI Primer Sets",
			"catalogNumbers": "D3008, D3096, D3097, D3098",
			"description": "Can barcode any library containing TruSeq<sup>®</sup> adapters. Now available in a 10-bp format for multiplexing up to 192 libraries.",
			"handle": "/products/zymo-seq-udi-primer-sets?",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d3008_d3096_zymo-seq_udi_primer_set_Indexes_1-96.png?v=1628532421&width=600",
			"generalIndex": "998",
			"id": "zymo-seq-udi-primer-sets?",
			"tags": [
				"transcriptomics",
				"epigenetics",
				"rrna-depletion-based",
				"oligo-dt-primer-based",
				"coding-and-a-variety-of-non-coding",
				"coding-only",
				"12-preps",
				"96-preps",
			],
			filters: []
		},
		"Zymo-Seq Trio WGBS Library Kit": {
			"title": "Zymo-Seq Trio WGBS Library Kit",
			"catalogNumbers": "D5462, D5463",
			"description": "The Zymo-Seq Trio WGBS Library Kit offers an optimized and reliable workflow for whole genome bisulfite sequencing (WGBS) library preparation from cell-free DNA (cfDNA), FFPE DNA, and gDNA. ",
			"handle": "/products/zymo-seq-trio-wgbs-library-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5462_Zymo-Seq-Cell-Free-DNA-WGBS-Library-Kit.jpg?v=1642623540&width=600",
			"generalIndex": "998",
			"id": "zymo-seq-trio-wgbs-library-kit",
			"tags": [
				"epigenetics",
				"24-preps",
				"96-preps",
				"5mc-whole-genome",
				"bisulfite",
			],
			filters: []
		},
		"Zymo-Seq WGBS Library Kit": {
			"title": "Zymo-Seq WGBS Library Kit",
			"catalogNumbers": "D5465",
			"description": "Zymo-Seq WGBS Library Kit is the only kit available for whole genome bisulfite (WGBS) library preparation in a single tube. The Kit incorporates tagmentation technology to eliminate the tedious fragmentation, enzymatic, and clean-up steps required by conventional, ligation-based library preparation methods. Reproducible genome coverage from any species (>90% of CpG sites detected in mammalian samples)",
			"handle": "/products/zymo-seq-wgbs-library-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d5465-zymo_seq_wgbs_library_kit.jpg?v=1628632445&width=600",
			"generalIndex": "998",
			"id": "zymo-seq-wgbs-library-kit",
			"tags": [
				"epigenetics",
				"24-preps",
				"5mc-whole-genome",
				"bisulfite",
			],
			filters: []
		},
		"Zymo-Seq RRBS Library Kit": {
			"title": "Zymo-Seq RRBS Library Kit",
			"catalogNumbers": "D5460, D5461",
			"description": "Zymo-Seq RRBS Library Kit is an all-in-one RRBS library prep kit that generates NGS libraries with a simplified workflow for the classic method Reduced Representation Bisulfite Sequencing (RRBS). This all-in-one RRBS library prep kit allows for DNA methylation profiling at single-nucleotide resolution in CpG-rich regions of the genome.",
			"handle": "/products/zymo-seq-rrbs-library-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d5460_ez_dna_methylation_rrbs_library_prep_kit_3045e660-6901-4f39-bdf2-0a00421995b9.png?v=1628706203&width=600",
			"generalIndex": "998",
			"id": "zymo-seq-rrbs-library-kit",
			"tags": [
				"epigenetics",
				"24-preps",
				"48-preps",
				"5mc-reduced-representation",
				"bisulfite",
			],
			filters: []
		},
		"Pico Methyl-Seq Library Prep Kit": {
			"title": "Pico Methyl-Seq Library Prep Kit",
			"catalogNumbers": "D5455, D5456",
			"description": "The Pico Methyl-Seq Library Prep Kit provides a streamlined workflow for making WGBS libraries. Input DNA is randomly fragmented during the initial bisulfite treatment step followed by three rounds of amplification with uniquely designed primers. The procedure can accommodate as little as 10 pg input DNA (including that derived from FFPE samples), making it ideal for methylation analysis of precious, limited, and target-enriched samples.",
			"handle": "/products/pico-methyl-seq-library-prep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d5456_pico-methyl-seq-library-prep-kit_1.jpg?v=1628532385&width=600",
			"generalIndex": "998",
			"id": "pico-methyl-seq-library-prep-kit",
			"tags": [
				"epigenetics",
				"10-preps",
				"25-preps",
				"5mc-whole-genome",
				"bisulfite",
			],
			filters: []
		},
		"RRHP 5-hmC Library Prep Kit": {
			"title": "RRHP 5-hmC Library Prep Kit",
			"catalogNumbers": "D5450, D5451",
			"description": "The RRHP 5-hmC Library Prep Kit is an all-inclusive solution for analysis of genome-wide 5-hydroxymethylcytosine (5-hmC) positions at single-base resolution. The Reduced Representation Hydroxymethylation Profiling (RRHP) method is based on blocking MspI digestion by glucosylating 5-hmC within MspI recognition sites. Fragments lacking glucosylated 5-hmC at the adapter-ligation junction will be cleaved and not amplified by PCR. Therefore, only fragments containing 5-hmC will be successfully amplified and analyzed by Next-Generation Sequencing. ",
			"handle": "/products/rrhp-5-hmc-library-prep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5450_RRHP_205-hmC_20Library_20Prep_20Kit.png?v=1628532403&width=600",
			"generalIndex": "998",
			"id": "rrhp-5-hmc-library-prep-kit",
			"tags": [
				"epigenetics",
				"12-preps",
				"25-preps",
				"5hmc",
				"non-bisulfite",
			],
			filters: []
		},
		"Zymo-Seq ATAC Library Kit": {
			"title": "Zymo-Seq ATAC Library Kit",
			"catalogNumbers": "D5458",
			"description": "Zymo-Seq ATAC Library Kit provides a simple and streamlined workflow for Assay for Transposase Accessible Chromatin with high throughput Sequencing (ATAC-Seq) library preparation from mammalian cell and tissue input. This all-inclusive kit features an easy to follow protocol capable of preparing ATAC-Seq libraries from as little as 50,000 cells in as little as 4 hours with minimal hands on time.",
			"handle": "/products/zymo-seq-atac-library-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5458-Zymo-Seq-ATAC-Library-Kit_2365_002_ProductPhoto.jpg?v=1677624838&width=600",
			"generalIndex": "998",
			"id": "zymo-seq-atac-library-kit",
			"tags": [
				"epigenetics",
				"12-preps",
				"non-bisulfite",
				"chromatin",
			],
			filters: []
		},
		"Zymo-Seq SPLAT DNA Library Kit": {
			"title": "Zymo-Seq SPLAT DNA Library Kit",
			"catalogNumbers": "D5464",
			"description": "The Zymo-Seq™ SPLAT DNA Library Kit is a versatile solution for DNA library preparation from a wide variety of sample types. ",
			"handle": "/products/zymo-seq-splat-dna-library-kit",
			"navigation_image": "https://files.zymoresearch.com/product-images/d5464_zymo-seq_splat_dna_library_kit_(12_prep).jpg",
			"generalIndex": "998",
			"id": "zymo-seq-splat-dna-library-kit",
			"tags": [
				"epigenetics",
				"genomics",
				"12-preps",
				"non-bisulfite",
				"fragmentomics",
				"whole-genome-dna-seq",
			],
			filters: []
		},
		"Quick-16S NGS Library Prep Kit": {
			"title": "Quick-16S NGS Library Prep Kit",
			"catalogNumbers": "D6400",
			"description": "Microbial composition profiling techniques powered by Next-Generation sequencing are becoming routine in microbiomics and metagenomics studies. However, these analytical techniques can suffer from significant bias from collection to analysis. The ZymoBIOMICS Microbial Community Standard is designed to assess bias and errors in the extraction methods of a microbiomics workflow. The Microbial Community Standard mimics a mixed microbial community of well-defined composition, containing three easy-to-lyse Gram-negative bacteria, five tough-to-lyse Gram-positive bacteria, and two tough-to-lyse yeasts. Acting as a defined input from the beginning, the Microbial Community Standard can guide construction and optimization of entire workflows and can also be used as a routine quality control. Theoretical Composition Based on Genomic DNA: Listeria monocytogenes - 12%, Pseudomonas aeruginosa - 12%, Bacillus subtilis - 12%, Escherichia coli - 12%, Salmonella enterica - 12%, Lactobacillus fermentum - 12%, Enterococcus faecalis - 12%, Staphylococcus aureus - 12%, Saccharomyces cerevisiae - 2%, and Cryptococcus neoformans - 2%.",
			"handle": "/products/quick-16s-ngs-library-prep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6400_Quick-16S_20NGS_20Library_20Prep_20Kit.png?v=1628532355&width=600",
			"generalIndex": "998",
			"tags": [
				"microbiomics",
				"96-preps",
			],
			filters: []
		},
		"Quick-16S Plus NGS Library Prep Kit (V4)": {
			"title": "Quick-16S Plus NGS Library Prep Kit (V4)",
			"catalogNumbers": "D6430-PS1, D6430-PS2, D6430-PS3, D6430-PS4, D6432",
			"description": "The Quick-16S Plus NGS Library Prep Kit (V4) is the fastest and simplest NGS library prep targeting the V4 region of the 16S rRNA gene for high-throughput sequencing. The automation-friendly protocol utilizes a premixed amplification plate and a single qPCR/PCR for combined targeted amplification and barcode addition. Pooling by equal volume and a single clean-up of the final library, rather than massive AMPure<sup>®</sup> bead-based clean-ups, simplifies the library prep process. Additional library quantification analysis such as TapeStation<sup>®</sup> analysis or gel electrophoresis are not necessary. With these features, the workflow dramatically reduces the hands-on time of library preparation to only 30 minutes.",
			"handle": "/products/quick-16s-plus-ngs-library-prep-kit-v4",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6430_Quick-16S-Plus-NGS-Library-Prep-Kit-_V4.jpg?v=1658345576&width=600",
			"generalIndex": "998",
			"tags": [
				"microbiomics",
				"96-preps",
			],
			filters: []
		},
		"Quick-ITS Plus NGS Library Prep Kit (UDI)": {
			"title": "Quick-ITS Plus NGS Library Prep Kit (UDI)",
			"catalogNumbers": "D6425-PS1, D6425-PS2, D6425-PS3, D6425-PS4",
			"description": "Quick-ITS Plus NGS Library Prep Kit (UDI) is the fastest and simplest NGS library prep targeting the ITS region for high-throughput sequencing. The automation-friendly protocol utilizes a single qPCR/PCR for combined targeted amplification and barcode addition using specially designed primers. After pooling by equal volume, a single clean-up of the final library is performed, rather than massive AMPure<sup>®</sup> bead-based clean-ups. Additional library quantification analysis such as TapeStation<sup>®</sup> analysis or gel electrophoresis are not necessary. With these features, the workflow dramatically reduces the hands-on time of library preparation to only 30 minutes.",
			"handle": "/products/quick-its-plus-ngs-library-prep-kit-udi",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d6424-quick_its_plus_ngs_library_prep_kit.jpg?v=1628532419&width=600",
			"generalIndex": "998",
			"tags": [
				"microbiomics",
				"96-preps",
			],
			filters: []
		},
		"Quick-16S Plus NGS Library Prep Kit (V3-V4, UDI)": {
			"title": "Quick-16S Plus NGS Library Prep Kit (V3-V4, UDI)",
			"catalogNumbers": "D6421-PS1, D6421-PS2, D6421-PS3, D6421-PS4, D6421-PS5, D6421-PS6, D6421-PS7, D6421-PS8",
			"description": "The Quick-16S Plus NGS Library Prep Kit (V3-V4, UDI) is the fastest and simplest NGS library prep targeting the V3-V4 region of the 16S rRNA gene for high-throughput sequencing. The automation-friendly protocol utilizes a single qPCR/PCR for combined targeted amplification and barcode addition using specially designed primers. After pooling by equal volume, a single clean-up of the final library is performed, rather than massive AMPure<sup>®</sup> bead-based clean-ups. Additional library quantification analysis such as TapeStation<sup>®</sup> analysis or gel electrophoresis are not necessary. With these features, the workflow dramatically reduces the hands-on time of library preparation to only 30 minutes.",
			"handle": "/products/quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/d6420-quick_16s_plus_ngs_library_prep_kit_5760x5760_b92f8884-354d-48bf-9660-e41bd948cd3f.jpg?v=1690506528&width=600",
			"generalIndex": "998",
			"tags": [
				"microbiomics",
				"96-preps",
			],
			filters: []
		},
		"Quick-16S Plus NGS Library Prep Kit (V1-V2)": {
			"title": "Quick-16S Plus NGS Library Prep Kit (V1-V2)",
			"catalogNumbers": "D6434-PS1",
			"description": "The Quick-16S Plus NGS Library Prep Kit (V1-V2) is the fastest and simplest NGS library prep targeting the V1-V2 region of the 16S rRNA gene for high-throughput sequencing. The automation-friendly protocol utilizes a single qPCR/PCR for combined targeted amplification and barcode addition using specially designed primers. After pooling by equal volume, a single clean-up of the final library is performed, rather than massive AMPure<sup>®</sup> bead-based clean-ups. Additional library quantification analysis such as TapeStation<sup>®</sup> analysis or gel electrophoresis are not necessary. With these features, the workflow dramatically reduces the hands-on time of library preparation to only 30 minutes.",
			"handle": "/products/quick-16s-plus-ngs-library-prep-kit-v1-v2",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/D6434Quick-16SNGSLibraryPrepKit_V1-V2.jpg?v=1701709549",
			"generalIndex": "998",
			"tags": [
				"microbiomics",
				"96-preps",
			],
			filters: []
		},
		"Quick-16S Plus NGS Library Prep Kit (V1-V3)": {
			"title": "Quick-16S Plus NGS Library Prep Kit (V1-V3)",
			"catalogNumbers": "D6440-PS1, D6440-PS2, D6440-PS3, D6440-PS4",
			"description": "The Quick-16S Plus NGS Library Prep Kit (V1-V3) is the fastest and simplest NGS library prep targeting the V1-V3 region of the 16S rRNA gene for high-throughput sequencing. The automation-friendly protocol utilizes a single qPCR/PCR for combined targeted amplification and barcode addition using specially designed primers. After pooling by equal volume, a single clean-up of the final library is performed, rather than massive AMPure<sup>®</sup> bead-based clean-ups. Additional library quantification analysis such as TapeStation<sup>®</sup> analysis or gel electrophoresis are not necessary. With these features, the workflow dramatically reduces the hands-on time of library preparation to only 30 minutes.",
			"handle": "/products/quick-16s-plus-ngs-library-prep-kit-v1-v3",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/D6440Quick-16SNGSLibraryPrepKit_V1-V3.jpg?v=1701709564",
			"generalIndex": "998",
			"tags": [
				"microbiomics",
				"96-preps",
			],
			filters: []
		},
		"Quick-16S/ITS NGS Library Prep Kit Sampler": {
			"title": "Quick-16S/ITS NGS Library Prep Kit Sampler",
			"catalogNumbers": "D6499",
			"description": "The Quick-16S/ITS™ NGS Library Prep Sampler provides 8 reactions from each of our Quick-16S/ITS™ Plus library prep kits as well as our Quick -16S™ Full-Length Library Prep Kit. Sample the Microbiomics library prep kit portfolio in one convenient format.",
			"handle": "/products/quick-16s-its-ngs-library-prep-sampler",
			"navigation_image": "https://files.zymoresearch.com/images/filter_page/microbiome/D6499.webp",
			"generalIndex": "998",
			"id": "quick-16s-its-ngs-library-prep-sampler",
			"tags": [
				"microbiomics",
				"48-preps",
			],
			filters: []
		},
		"Quick-16S Full-Length Library Prep Kit": {
			"title": "<i>Quick</i>-16S Full-Length Library Prep Kit",
			"catalogNumbers": "D6450-PS1, D6450-PS2, D6450-PS3, D6450-PS4",
			"description": "The <i>Quick</i>-16S Full-Length Library Prep Kit delivers pooled and purified libraries ready for downstream sequencing on PacBio & Oxford Nanopore sequencing platforms in as little as 30 minutes of hands-on time.",
			"handle": "/products/quick-16s-full-length-library-prep-kit",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/files/D6450-BQuick-16SFullLengthLibraryKit_600x.webp",
			"generalIndex": "998",
			"id": "quick-16s-full-length-library-prep-kit",
			"tags": [
				"microbiomics",
				"96-preps",
			],
			filters: []
		},
	}
}